
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intellihire",
      function () {
        return require("private-next-pages/intellihire.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intellihire"])
      });
    }
  